export default {
      id: "small-attention-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "sprite-46b249.svg#small-attention-usage",
      toString: function () {
        return this.url;
      }
    }